import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { Customer } from "../customers/customer";

export const ProductInventoryCustomer = types.compose(
  Customer,
  types.model({
    name: types.maybeNull(types.string),
    code: types.maybeNull(types.string),
  })
);
export interface IProductInventoryCustomer
  extends Instance<typeof ProductInventoryCustomer> {}

export const ProductInventory = types.model({
  id: "",
  name: types.maybeNull(types.string),
  code: types.maybeNull(types.string),
  barcode: types.maybeNull(types.string),
  unitOfCalculation: types.maybeNull(types.string),
  customerId: types.maybeNull(types.string),
  customer: types.maybeNull(ProductInventoryCustomer),
  importQuantity: types.maybeNull(types.number),
  exportQuantity: types.maybeNull(types.number),
  totalQuantity: types.maybeNull(types.number),
});

export interface IProductInventory extends Instance<typeof ProductInventory> {}
export interface IProductInventoryProperties
  extends SnapshotIn<typeof ProductInventory> {}
